/** @format */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { DEFAULT_TEST_ID } from './config/constants';
import { KitStatTileProps } from './config/types';
import { styles } from './kit-stat-tile.styles';

export * from './config/constants';
export type { KitStatTileProps } from './config/types';

const StyledKitStatTile = styled.div`
    ${styles}
`;

/**
 * The export gives only `value` and `label`, so a long label simply wraps
 * onto its own line beneath the value rather than being split deliberately.
 */
export const KitStatTile: FunctionComponent<KitStatTileProps> = ({
    stat,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => (
    <StyledKitStatTile data-testid={dataTestId} {...otherProps}>
        <span
            className="kit-stat-tile-value"
            data-testid={`${dataTestId}__value`}
        >
            {stat.value}
        </span>
        <span className="kit-stat-tile-label">{stat.label}</span>
    </StyledKitStatTile>
);
